<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="regimeAlimentaireSvc"></yo-generic-datagrid-pn>
